import EditorBase from "../../../bryntum-lib/editors/base/EditorBase.jsx";
import { columnAvatarString, getOriginalRecord } from "../../../other/utils/utils.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";

class SwivuNotifyRecipientPopup extends EditorBase {
  static get configurable() {
    return {
      title: "Notify Recipients",
      width: "30em",
      height: "30em",
      scrollable: true,
      autoClose: false,
      closeAction: "destroy",
      closable: true,
      cls: 'minimal-gradient-editor !resize-none',
      autoShow: false,
      resize: false,
      modal: true,
      items: {
        emptyText: {
          type: "displayfield",
          value: "No recipients",
          hidden: true,
        },
        userLists: {
          type: "list",
          cls: "user-list",
          flex: "1 1 100%",
          listeners: {
            item: "up.onItemClicked"
          },
          itemTpl: (record) => columnAvatarString(record.name, record.profileImageURL),
        }
      }
    }
  }

  editRecord(reminderRecord, context) {
    super.editRecord(reminderRecord, context, { isFirstShow: true });
    this.context = context;
    this.changeCrossToEsc();

    const usersRecord = getOriginalRecord(reminderRecord).alertRecipientAlternate.map((recipient) => recipient.userRecord);
    this.widgetMap.emptyText.hidden = usersRecord.length;
    this.widgetMap.userLists.items = usersRecord;

  }

  onItemClicked({ record }) {
    const user = this.context.project.boardUsersStore.getById(record.id);
    this.context.editorHandler.openEditor(EDITOR_KEYS.userEditor, user, { user: user }, { by: "recordType", useExisting: true });
  }

}

export default SwivuNotifyRecipientPopup;
